import { extendTheme } from "@chakra-ui/react";
const config = {
  initialColorMode: "dark",
  useSystemColorMode: false,
};
const theme = extendTheme({
  config,
  colors: {
    neonBlue: {
      50: "#e6f9ff",
      100: "#b3e6ff", 
      200: "#80d2ff",
      300: "#4dbfff",
      400: "#1aabff",
      500: "#0099ff",
      600: "#007acc",
      700: "#005c99",
      800: "#003d66",
      900: "#001f33",
    },
    neonGreen: {
      50: "#e6fff2",
      100: "#b3ffdb",
      200: "#80ffc5", 
      300: "#4dffae",
      400: "#1aff98",
      500: "#00ff85",
      600: "#00cc6a",
      700: "#009950",
      800: "#006635",
      900: "#00331a",
    },
    neonPurple: {
      50: "#f2e6ff",
      100: "#d9b3ff",
      200: "#c080ff",
      300: "#a64dff",
      400: "#8d1aff",
      500: "#7700ff",
      600: "#5f00cc",
      700: "#470099",
      800: "#2e0066",
      900: "#170033",
    },
    darkBg: {
      900: "#0a0a0f",
      800: "#12121a",
      700: "#1a1a25",
      600: "#22222f",
      500: "#2a2a3a",
    },
  },
  fonts: {
    heading: "'JetBrains Mono', monospace",
    body: "'Inter', sans-serif",
    mono: "'JetBrains Mono', monospace",
  },
  styles: {
    global: (props) => ({
      body: {
        bg: "darkBg.900",
        color: "whiteAlpha.900",
      },
      html: {
        scrollBehavior: "smooth",
      },
      "::selection": {
        backgroundColor: "neonBlue.600",
        color: "white",
      },
      "::-webkit-scrollbar": {
        width: "8px",
        backgroundColor: "darkBg.800",
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: "neonBlue.600",
        borderRadius: "4px",
      },
    }),
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: "500",
        borderRadius: "md",
        _focus: {
          boxShadow: "0 0 0 3px rgba(0, 153, 255, 0.6)",
        },
      },
      variants: {
        neonBlue: {
          bg: "transparent",
          color: "neonBlue.400",
          border: "1px solid",
          borderColor: "neonBlue.400",
          _hover: {
            bg: "rgba(26, 171, 255, 0.15)",
            boxShadow: "0 0 15px rgba(26, 171, 255, 0.5)",
          },
        },
        neonGreen: {
          bg: "transparent",
          color: "neonGreen.400",
          border: "1px solid",
          borderColor: "neonGreen.400",
          _hover: {
            bg: "rgba(26, 255, 152, 0.15)",
            boxShadow: "0 0 15px rgba(26, 255, 152, 0.5)",
          },
        },
        neonPurple: {
          bg: "transparent",
          color: "neonPurple.400",
          border: "1px solid",
          borderColor: "neonPurple.400",
          _hover: {
            bg: "rgba(141, 26, 255, 0.15)",
            boxShadow: "0 0 15px rgba(141, 26, 255, 0.5)",
          },
        },
        solidNeon: {
          bg: "neonBlue.500",
          color: "white",
          _hover: {
            bg: "neonBlue.600",
            boxShadow: "0 0 15px rgba(0, 153, 255, 0.7)",
          },
        },
      },
    },
    Heading: {
      baseStyle: {
        fontWeight: "700",
      },
    },
    Link: {
      baseStyle: {
        color: "neonBlue.400",
        _hover: {
          textDecoration: "none",
          color: "neonBlue.300",
        },
      },
    },
  },
});
export default theme;